// extracted by mini-css-extract-plugin
export default {"container":"AdminViewWidget_container__cS0WC"};